import { useGetAllFeatureFlagQuery } from '../features/featureFlag/featureFlagApi';
import { ICON_LIBRARY_FEATURE_FLAG } from '../constants';
import { FeatureFlagData } from '../types';

export const useIconLibraryFlag = (enabled = true): { isIconLibraryEnabled: boolean; isFlagLoading: boolean } => {
    const { data: featureFlags, isLoading } = useGetAllFeatureFlagQuery({}, { skip: !enabled });
    const flag = featureFlags?.data?.find(
        (f: FeatureFlagData) => f.featureFlagName.toLowerCase() === ICON_LIBRARY_FEATURE_FLAG
    );
    return { isIconLibraryEnabled: Boolean(flag?.enabled), isFlagLoading: isLoading };
};
